/* unplugin-vue-components disabled */import { render } from "./FlowsPanel.vue?vue&type=template&id=6a1dc506"
import script from "./FlowsPanel.vue?vue&type=script&lang=js"
export * from "./FlowsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__